import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import posed from "react-pose";
import Select from "react-select";

import { withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";

import HistoryIcon from "@material-ui/icons/HistoryRounded";
import LocationIcon from "@material-ui/icons/LocationOn";
import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

import MenuDropdown from "./Dashboard/MenuDropdown";
import {
  THEME_COLORS,
  LIMIT_SIZE,
  APPBAR_HEIGHT,
  FoodBookLogo
} from "../utils/Constants";
import { reduceMenuList } from "../store/actionCreators/menuList";
import {
  setSearchText,
  clearSearchText
} from "../store/actionCreators/searchText";
import { WELCOME_PAGE_URL, DASHBOARD_PAGE_URL } from "../utils/Route";
import DesktopRestSearch from "./AppBar/RestSearch";
import GlobalSearch from "./AppBar/GlobalSearch";
import { clearSearchNotify } from "../store/actionCreators/searchNotify";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  LimitSize: {
    maxWidth: LIMIT_SIZE,
    width: "100%",
    margin: "0 auto",
    height: APPBAR_HEIGHT.desktop
  },
  Header: {
    backgroundColor: "#F37020"
    // backgroundColor: "white",
  },
  HeaderTransparent: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  DashboardImage: {},
  SearchBox: {
    // borderBottom: "1px solid white",
    color: "white",
    padding: "2% 10px 10px 10px",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.up("xl")]: {
      padding: "3% 10px 10px 10px"
    },
    [theme.breakpoints.down("md")]: {
      padding: "1% 10px 10px 10px"
    }
  },
  Underline: {
    "&:before": {
      borderBottom: "2px solid white"
    },
    "&:after": {
      borderBottom: "2px solid white"
    },
    "&:focus": {
      borderBottom: "2px solid white"
    },
    "&:hover:not($disabled):not($error):not($focused):before": {
      borderBottomColor: "white !important"
    }
    // "&:hover:not($disabled):after": {
    //   borderBottom: "1px solid white"
    // },
    // "&:hover:not($disabled):before": {
    //   borderBottom: "1px solid white"
    // }
  },
  adornment: {
    maxHeight: "2.5em",
    [theme.breakpoints.up("xs")]: {
      maxHeight: "3.5em"
    },
    [theme.breakpoints.down("md")]: {
      maxHeight: "2em"
    }
  },
  Center: {
    position: "relative",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  InputIcon: {
    color: "white"
  },
  ClearIconStyle: {
    color: "white",
    cursor: "pointer"
  },
  ShoppingStyle: {
    width: "2rem",
    height: "2rem",
    color: "white"
  },
  LocationText: {
    color: "white",
    margin: "0px",
    fontSize: "1rem",
    display: "inline-block",
    position: "absolute",
    top: "50%",
    width: "90%",
    left: "50%",
    overflow: "hidden",
    height: "2rem",
    transform: "translate(-50%,-50%)",
    cursor: "pointer",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
});

class DashboardDesktopHeader extends Component {
  constructor(props) {
    super(props);
    let currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    // currentFoodCourt = JSON.parse(currentFoodCourt);

    this.state = {
      pose: "close",
      searchText: props.searchText,
      currentFoodCourt: currentFoodCourt.label
    };

    this.timeoutRef = null;
  }

  profileClickHandler = () => {
    // Show and hide the dropdown

    if (this.state.pose === "open") {
      this.setState({ pose: "close" });
    } else {
      this.setState({ pose: "open" });
    }
  };

  searchTextOnChange = event => {
    const newSearchText = event.target.value;
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      searchId,
      isBuffet,
      searchText,
      allergens
    } = this.props;
    this.setState({ searchText: newSearchText });
    this.props.clearSearchNotify();
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      if (newSearchText.length > 2) {
        this.props.searchForText(immutableMenuList, {
          immutableSubMenu,
          currentSession,
          filters,
          restaurantIsAlive,
          selectedDate,
          searchId,
          servingTime,
          isBuffet,
          allergens,
          searchText: newSearchText
        });
      } else {
        this.props.clearSearchText(immutableMenuList, {
          immutableSubMenu,
          currentSession,
          filters,
          restaurantIsAlive,
          selectedDate,
          servingTime,
          searchId,
          isBuffet,
          allergens,
          searchText: ""
        });
      }
    }, 350);
  };

  clearSearch = () => {
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      isBuffet,
      searchId,
      allergens,
      searchText
    } = this.props;
    this.props.clearSearchNotify();

    this.setState({ searchText: "" });
    this.props.clearSearchText(immutableMenuList, {
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      searchId,
      isBuffet,
      allergens,
      searchText: ""
    });
  };

  closeMenu = () => {
    // Close the dropdown
    this.setState({ pose: "close" });
  };

  render() {
    const {
      classes,
      hideSearchBar,
      disableLocationSelection,
      location,
      searchItemClick
    } = this.props;
    const { searchText, currentFoodCourt } = this.state;
    const {
      root,
      LimitSize,
      Header,
      SearchBox,
      ShoppingStyle,
      Center,
      Icon,
      ClearIconStyle,
      Underline,
      LocationText
    } = classes;

    let globalSearchShow = false;
    let localSearchShow = false;
    const pathnameSplit = location.pathname.split("/");
    if (
      pathnameSplit[1] === "dashboard" &&
      pathnameSplit[2] === "restaurants"
    ) {
      globalSearchShow = true;
    }
    if (pathnameSplit[1] === "restaurant") {
      localSearchShow = true;
    }
    return (
      <div className={root}>
        <AppBar
          position="fixed"
          className={Header}
          onClick={e => e.stopPropagation()}
        >
          <Toolbar variant="dense">
            <div className={LimitSize}>
              <Grid
                container
                style={{ width: "100%", height: "100%" }}
                justify="space-between"
              >
                <Grid item>
                  <img
                    src={FoodBookLogo}
                    alt="logo"
                    className={Center}
                    style={{
                      height: APPBAR_HEIGHT.desktop,
                      cursor: "pointer",
                      padding: "14px"
                    }}
                    onClick={() => this.props.history.push(DASHBOARD_PAGE_URL)}
                  />
                </Grid>
                <Grid item xs>
                  <Grid container item xs>
                    {globalSearchShow && (
                      <GlobalSearch
                        searchBarShow
                        searchText={searchText}
                        searchTextOnChange={this.searchTextOnChange}
                        classNames={classes}
                        clearSearch={this.clearSearch}
                        searchItemClick={searchItemClick}
                      />
                    )}
                    {localSearchShow && (
                      <DesktopRestSearch
                        searchBarShow
                        searchText={searchText}
                        searchTextOnChange={this.searchTextOnChange}
                        classes={classes}
                        clearSearch={this.clearSearch}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={3} style={{ position: "relative" }}>
                  <p
                    className={LocationText}
                    onClick={this.props.selectFoodCourt}
                    style={{
                      cursor: disableLocationSelection ? "default" : "pointer"
                    }}
                  >
                    <LocationIcon
                      style={{ position: "relative", top: "5px" }}
                    />
                    {currentFoodCourt}
                  </p>
                </Grid>
                <Grid item style={{ position: "relative" }}>
                  <ClickAwayListener onClickAway={this.closeMenu}>
                    <div className={Center}>
                      {/* Please don't remove the below commented code it is needed for future use */}
                      {/* <Avatar
                        alt="User Image"
                        src={sampleAvatar}
                        style={{ cursor: "pointer", zIndex: 99 }}
                        onClick={this.profileClickHandler}
                      /> */}
                      <AccountCircleIcon
                        className={ShoppingStyle}
                        style={{
                          cursor: "pointer",
                          zIndex: 99,
                          display: "block"
                        }}
                        onClick={this.profileClickHandler}
                      />
                      <MenuDropdown
                        pose={this.state.pose}
                        closeMenu={this.closeMenu}
                        logoutHandler={this.props.logoutHandler}
                      />
                    </div>
                  </ClickAwayListener>
                </Grid>
              </Grid>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let searchBarState = {};
  if (!ownProps.hideSearchBar) {
    searchBarState = {
      isBuffet: state.currentRestaurantDetails.restextras.isbuffet,
      restaurantIsAlive: state.currentRestaurantDetails.resturantalive,
      servingTime: state.currentRestaurantDetails.servingtime
    };
  }
  return {
    allergens: state.allergens,
    immutableMenuList: state.immutableMenuList,
    immutableSubMenu: state.immutableSubMenu,
    searchText: state.searchText,
    filters: state.filters,
    searchId: state.searchId,
    selectedDate: state.selectedDate,
    currentSession: state.currentSession,
    ...searchBarState
  };
};

const mapDispatchToProps = dispatch => {
  return {
    searchForText: (data, options) => {
      dispatch(reduceMenuList(data, options));
      dispatch(setSearchText(options.searchText));
    },
    clearSearchText: (data, options) => {
      dispatch(reduceMenuList(data, options));
      dispatch(clearSearchText());
    },
    clearSearchNotify: () => {
      dispatch(clearSearchNotify());
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(DashboardDesktopHeader))
);



// WEBPACK FOOTER //
// ./src/components/DashboardDesktopHeader.js